import { ParameterTemplate } from './parameterTemplates';

export const validateNodeConfiguration = ( nodeConfig: any, template?: ParameterTemplate): boolean => {
  if (!template) {
    return true; // No template means no validation required
  }

  const parameters = nodeConfig?.parameters || {};

  // Check all required parameters
  for (const [key, config] of Object.entries(template)) {
    if (config.required) {
      const value = parameters[key];

      // Check if value is missing or empty (allow 0, false as valid values)
      if (value === null || value === undefined || (typeof value === 'string' && !value.trim())) {
        return false;
      }
    }
  }

  return true;
};

export const hasValidationErrors = (nodeConfig: any, template?: ParameterTemplate): boolean => {
  return !validateNodeConfiguration(nodeConfig, template);
};